import React, { useState } from "react";
import Input from "../components/input/Input";
import { FieldValues, SubmitHandler, useForm } from "react-hook-form";
import { toast } from "react-hot-toast";
import { adminRequest } from "../requestMethods";
import { useUserStore } from "../states/userState";
type Props = {};

function Signin({ }: Props) {
	const { setAuth } = useUserStore();
	const [isLoading, setIsLoading] = useState(false);

	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm<FieldValues>();

	const onSubmit: SubmitHandler<FieldValues> = async (userData) => {
		// adminRequest
		setIsLoading(true);
		try {
			const { data } = await adminRequest.post("/auth/signin", userData);
			setAuth(data.user, data.token);

			// set local storage
			const authData = {
				token: data.token,
				user: JSON.stringify(data.user),
			};
			localStorage.setItem("auth", JSON.stringify(authData));
			// refresh the page
			window.location.reload();
			toast.success("Login Successfully!");
		} catch (error) {
			const errMsg = (error as any).message;
			errMsg ? toast.error(errMsg) : toast.error("Something went wrong!");
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div className="flex h-screen items-center justify-center bg-gradient-to-r from-green-400 to-blue-500">
			<div className="h-fit w-96 space-y-8 rounded-lg bg-white px-6 py-16 shadow-lg">
				<div>
					<h1 className="text-center text-3xl font-semibold text-aquaBlue">
						Sign In
					</h1>
				</div>
				<form
					className="flex flex-col gap-4"
					onSubmit={handleSubmit(onSubmit)}
				>
					<Input
						register={register}
						errors={errors}
						id={"email"}
						name="email"
						type="email"
						label="Email"
						required
					/>
					<Input
						register={register}
						errors={errors}
						id={"password"}
						name="password"
						type="password"
						label="Password"
						required
					/>
					<button
						type="submit"
						disabled={isLoading}
						className={`cursor-pointer rounded-lg px-4 py-2 text-lg font-semibold text-white flex items-center justify-center ${isLoading
								? 'bg-gray-400 cursor-not-allowed'
								: 'bg-aquaBlue hover:bg-aquaBlue/90'
							}`}
					>
						{isLoading ? (
							<>
								<svg
									className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
									xmlns="http://www.w3.org/2000/svg"
									fill="none"
									viewBox="0 0 24 24"
								>
									<circle
										className="opacity-25"
										cx="12"
										cy="12"
										r="10"
										stroke="currentColor"
										strokeWidth="4"
									></circle>
									<path
										className="opacity-75"
										fill="currentColor"
										d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
									></path>
								</svg>
								Signing in...
							</>
						) : (
							'Sign In'
						)}
					</button>
				</form>
			</div>
		</div>
	);
}

export default Signin;
